import React, {useState} from 'react'
import moment from 'moment'

const NewCalendarContext = React.createContext(null)

function NewCalendarContextProvider(props) {
  const [calendarView, setCalendarView] = useState('month')
  const [startDate, setStartDate] = useState(
    moment()
      .clone()
      .startOf('month')
  )

  const [openSidebar, setOpenSidebar] = useState(false)

  const goToBack = () => {
    if (calendarView === 'month') {
      setStartDate(moment(startDate).subtract(1, 'months'))
    }
  }
  const goToNext = () => {
    setStartDate(moment(startDate).add(1, 'months'))
  }

  const value = {
    startDate,
    setStartDate,
    calendarView,
    setCalendarView,
    openSidebar,
    setOpenSidebar,
    goToBack,
    goToNext,
  }

  return <NewCalendarContext.Provider value={value}>{props.children}</NewCalendarContext.Provider>
}

const NewCalendarContextConsumer = NewCalendarContext.Consumer

export {NewCalendarContext, NewCalendarContextProvider, NewCalendarContextConsumer}
